import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootEl = document.getElementById("root");
const isPrerendered = rootEl.hasAttribute("data-prerendered") && window.location.pathname === "/";

// Set hydration flag BEFORE React renders so HydrationProvider reads it
window.__HYDRATING__ = isPrerendered;

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (isPrerendered) {
  // Prerendered HTML exists — hydrate (attach to existing DOM, no rebuild)
  ReactDOM.hydrateRoot(rootEl, app);
} else {
  // No prerendered content (or homepage snapshot served on a non-homepage path) — standard client render
  rootEl.innerHTML = "";
  ReactDOM.createRoot(rootEl).render(app);
}
